<template>
  <b-modal
    no-close-on-esc 
    no-close-on-backdrop
    hide-footer
    hide-header-close
    scrollable
    v-model="value"
    size="xl"
    :title="$t('Add Contributor')"
    >

    <contributor-search
        v-if="value && state == 'search'"
        :type="holder.InstanceType"
        :provider-id="holder.SourceProviderID" 
        :sub-provider-id="holder.SourceSubProviderID"
        :role-defs="roleDefs['Contributors.Role'] "
        @done="addDone"
        @add="addContributor"
      />

    <contributor-create-form
      v-if="value && state == 'create'"
      :defs="roleDefs"
      :role-picker="true"
      @cancel="$emit('input', false)"
      @create="addContributor"
    />
  </b-modal>
</template>

<script>
  export default {
    name: 'ContributorAdd',
    components: {
      "contributor-search": () => import("@/components/ContributorSearch"),
      "contributor-create-form": () => import("@/components/ContributorCreateForm"),
    },
    data () {
      return {
        state: 'search'
      }
    },
    props: {
      value: Boolean,
      holder: [String, Object],
      holderId: String,
    },
    watch: {
      value(newValue) {
        if (!newValue) {
          this.state == 'search'
        }
      }
    },
    computed: {
      holderType () {
        if (!this.holder) return false
        if (this.holder.InstanceType) return this.holder.InstanceType
        return this.holder
      },
      roleDefs() {
        return this.$root.$data.fieldDefs[this.holderType]
      },
    },
    methods: {
      addDone(event) {
        if (event == 'createNew') {
          this.state = 'create'
        } else {
          this.$emit('input', false)
        }
      },
      addContributor (contributor, roles) {
        if (!Array.isArray(roles)) roles = [roles]
        this.$emit('add', contributor, roles)
        this.$emit('input', false)
      }
    },
    mounted () {

    }
  }
</script>

<style lang="scss">

</style>